import React from 'react';
import propTypes from 'prop-types';
import { UiTable } from 'src/ui';
import { startsWithCaseInsensitive } from '../../ui';

const tableColumns = [
  {
    Header: 'Email Address',
    accessor: 'email_address',
    filterMethod: (_filter, row) => {
      return [row._original.email_address].some(v =>
        v.toLowerCase().includes(_filter.value.toLowerCase())
      );
    },
    Cell: row => <div className="has-text-centered">{row.value}</div>,
    width: 300,
  },
  {
    Header: 'Status',
    accessor: 'status',
    filterMethod: startsWithCaseInsensitive,
    Cell: row => <div className="has-text-centered">{row.value}</div>,
  },
  {
    Header: 'Date',
    accessor: 'date',
    filterable: false,
    Cell: row => <div className="has-text-centered">{row.value}</div>,
  },
  {
    Header: 'OS',
    accessor: 'OS',
    filterMethod: startsWithCaseInsensitive,
    Cell: row => <div className="has-text-centered">{row.value}</div>,
  },
  {
    Header: 'Browser',
    accessor: 'browser',
    filterMethod: startsWithCaseInsensitive,
    Cell: row => <div className="has-text-centered">{row.value}</div>,
  },
  {
    Header: 'IP Address',
    accessor: 'ip',
    filterable: false,
    Cell: row => <div className="has-text-centered">{row.value}</div>,
  },
  {
    Header: 'Details',
    accessor: 'details',
    filterable: false,
    Cell: row => <div className="has-text-wrapped">{row.value || ''}</div>,
    width: 250,
  },
];

export const LoginHistoryTable = ({ loading, data }) => (
  <UiTable
    className="transactions-table -striped -highlight"
    columns={tableColumns}
    loading={loading}
    data={data}
    useTablePagination
    resolveData={data =>
      data.map(transaction => ({
        ...transaction,
      }))
    }
    title="Login History"
    hideButton
    hideNext
    hidePrev
    filterable
  />
);

LoginHistoryTable.propTypes = {
  loading: propTypes.bool.isRequired,
  data: propTypes.arrayOf(propTypes.object).isRequired,
};
